<template>
  <div>
    <com-dialog
      :visible.sync="visible"
      width="1100px"
      :title="type === 'created' ? '新增' : '编辑'"
    >
      <div>
        <div class="flex items-center">
          <div class="form_item flex items-center">
            <div class="label">名称</div>
            <el-input style="width: 150px" v-model="form.name"></el-input>
          </div>
          <div class="form_item flex items-center ml-15px">
            <div class="label">商家分成</div>
            <el-input style="width: 150px" v-model="form.divide">
              <template slot="append">%</template>
            </el-input>
          </div>
        </div>
        <div class="form_item mtb-15px">
          <div class="flex items-center">
            <div class="label">价格设置</div>
            <el-button type="text" @click="handleAddCombo">添加</el-button>
          </div>
          <div class="flex flex-wrap">
            <div
              v-for="(item, index) in form.planList"
              :key="index"
              class="mb-15px relative price_wrapper flex flex-col justify-center w-500px mr-20px"
            >
              <div class="flex items-center">
                <div class="label">功率</div>
                <el-input
                  placeholder="请输入"
                  :value="item.minPower"
                  @input="(val) => handleInput('minPower', index, val)"
                  style="width: 150px"
                >
                  <template slot="append">W</template>
                </el-input>
                <div class="mlr-5px">-</div>
                <el-input
                  placeholder="请输入"
                  :value="item.power"
                  @input="(val) => handleInput('power', index, val)"
                  style="width: 150px"
                >
                  <template slot="append">W</template>
                </el-input>
              </div>
              <div class="pl-20px mt-20px">
                <div class="flex items-center">
                  <div class="label">套餐设置</div>
                </div>
                <div class="flex flex-wrap items-center">
                  <div class="mb-10px mr-15px plr-15px ptb-15px combo_wrapper relative">
                    <div class="flex items-center">
                      <div class="label">充电时长</div>
                      <el-input
                        placeholder="请输入"
                        :value="item.minute"
                        @input="(val) => handleInput('minute', index, val)"
                        class="w-180px"
                      >
                        <template slot="append">小时</template>
                      </el-input>
                    </div>
                    <div class="flex items-center mtb-10px">
                      <div class="label">月卡时长</div>
                      <el-input
                        placeholder="请输入"
                        :value="item.duration"
                        @input="(val) => handleInput('duration', index, val)"
                        class="w-180px"
                      >
                        <template slot="append">月</template>
                      </el-input>
                    </div>
                    <div class="flex items-center">
                      <div class="label">套餐金额</div>
                      <el-input
                        placeholder="请输入"
                        :value="item.money"
                        @input="(val) => handleInput('money', index, val)"
                        class="w-180px"
                      >
                        <template slot="append">元</template>
                      </el-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="remove" @click="removeCombo(item, index)">
                <i class="el-icon-remove"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="form_item flex items-center mtb-15px">
          <div class="label">适用网点</div>
          <el-input
            placeholder="网点名"
            style="width: 200px"
            v-model="defaultParams.name"
          ></el-input>
          <div class="mlr-6px">
            <com-region :regionId.sync="defaultParams.regionId"></com-region>
          </div>
          <div>
            <el-button type="primary" size="mini" @click="handleCheck">查询</el-button>
            <el-button size="mini" @click="handleClear">清空条件</el-button>
          </div>
        </div>
        <div class="mtb-10px">
          当前已选中 {{ (form.storeList && form.storeList.length) || 0 }} 个网点
        </div>
        <div>
          <com-table
            :columns="tableColumns"
            :api="api"
            :defaultSelect="form.storeList"
            selection
            @selection-change="handleSelectionChange"
            ref="table"
            :default-params="tableQuery"
          ></com-table>
        </div>
        <div class="mt-15px flex justify-end">
          <el-button @click="close"> 取消 </el-button>
          <el-button type="primary" @click="handleSubmit"> 确定 </el-button>
        </div>
      </div>
    </com-dialog>
  </div>
</template>

<script>
import { siteListApi } from '@/api/site'
import { add, detail, edit } from '@/api/monthly_card'
import utils from 'my-tools-library'

export default {
  data() {
    return {
      visible: false,
      type: 'created',
      tableColumns: [
        {
          label: '编号',
          prop: 'number'
        },
        {
          label: '网点名称',
          prop: 'name'
        },
        {
          label: '所在区域',
          prop: 'areaName'
        },
        {
          label: '地址',
          prop: 'address'
        }
      ],
      defaultParams: {
        name: '',
        regionId: []
      },
      api: siteListApi,
      form: {
        name: '',
        planList: [],
        storeList: [],
        divide: ''
      },
      tableQuery: {}
    }
  },
  methods: {
    open(opt) {
      const { code, type } = opt
      this.type = type
      this.form = {}

      if (type === 'created') {
        this.tableQuery.boundMonthCard = true
        this.form.planList = [
          {
            type: 1,
            minPower: '',
            power: '',
            money: '',
            minute: '',
            duration: ''
          }
        ]
      }
      if (code) {
        this.getDetail(code)
      }
      this.visible = true

      setTimeout(() => {
        this.$refs.table.init()
      }, 100)
    },
    close() {
      this.visible = false
      setTimeout(() => {
        this.form = {}
        this.tableQuery = {} // 清空查询条件
      }, 200)
    },

    getDetail(code) {
      detail({ code }).then((res) => {
        const { monthCard } = res.data
        this.form = utils.deepClone(monthCard)
        if (this.form.divide) this.form.divide *= 100
        this.$forceUpdate()
      })
    },
    handleSelectionChange(e) {
      const arr = []

      e.forEach((item) => {
        const param = {
          refStore: item.code,
          name: item.name
        }
        arr.push(param)
      })
      this.form.storeList = [...arr]
    },
    handleCheck() {
      const params = {
        name: this.defaultParams.name
      }
      if (this.defaultParams.regionId.length) {
        params.area = this.defaultParams.regionId.at(-1)
      }
      this.$refs.table.search(params)
    },
    handleClear() {
      this.defaultParams = {}
      this.$refs.table.search(this.defaultParams)
    },
    handleAdd() {
      const params = { ...this.form }
      if (params.divide) params.divide /= 100
      add(utils.cleanObject(params)).then((res) => {
        if (res.status === 200) {
          this.$message.success('操作成功')
          this.$emit('success')
          this.close()
        }
        console.log('res :>> ', res)
      })
    },
    handleEdit() {
      console.log('编辑 :>> ', this.form)
      const params = { ...this.form }
      if (params.divide) params.divide /= 100
      edit(params).then(() => {
        this.$message.success('操作成功')
        this.$emit('success')
        this.close()
      })
    },
    handleSubmit() {
      if (this.type === 'edit') {
        this.handleEdit()
        return
      }
      this.handleAdd()
    },
    handleInput(type, index, val) {
      this.form.planList[index][type] = val
      this.$forceUpdate()
    },
    // 添加月卡套餐
    handleAddCombo() {
      const params = {
        type: 1,
        minPower: '',
        power: '',
        money: '',
        minute: '',
        duration: ''
      }
      this.form.planList.push(params)
      this.$forceUpdate()
      console.log('this.form :>> ', this.form)
    },
    // 移除月卡套餐
    removeCombo(row, index) {
      console.log('row :>> ', row, index)
      this.form.planList.splice(index, 1)
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss" scoped>
.form_item {
  .label {
    width: 80px;
  }
  .input {
    .el-input__inner {
      width: 300px !important;
    }
  }

  .price_wrapper {
    border: solid 1px rgba(0, 0, 0, 0.1);
    border-radius: 16px;
    padding: 16px 10px 0 16px;
    .remove {
      position: absolute;
      top: -10px;
      right: -10px;
      cursor: pointer;
    }
  }
}
</style>
